import { createContext } from 'react';
export const DraggingPageContext = createContext({
    draggingPageId: null,
    setDraggingPageId: () => { }
});
